// Helper function to generate colors for pie chart
export const generateColors = (count) => {
  const colors = [
    '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF',
    '#FF9F40', '#FF6384', '#C9CBCF', '#4BC0C0', '#FF6384'
  ];
  
  return Array.from({ length: count }, (_, i) => colors[i % colors.length]);
};

export const isWeekend = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDay();
  return day === 0 || day === 6; // Sunday = 0, Saturday = 6
};

// Helper functions for chart interactions
export const validateClickData = (data, elements) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return false;
  }
  
  if (!elements || !Array.isArray(elements) || elements.length === 0) {
    return false;
  }
  
  return true;
};

export const processCountryData = (countryDistribution) => {
  if (!countryDistribution || !Array.isArray(countryDistribution)) {
    return [];
  }

  // Sort countries by count and limit to top 10
  const sortedCountries = [...countryDistribution]
    .sort((a, b) => b.count - a.count)
    .slice(0, 10);

  // Calculate "Others" if there are more than 10 countries
  const topCountriesCount = sortedCountries.reduce((sum, country) => sum + country.count, 0);
  const totalCount = countryDistribution.reduce((sum, country) => sum + country.count, 0);
  const othersCount = totalCount - topCountriesCount;

  let finalCountries = [...sortedCountries];
  if (othersCount > 0) {
    finalCountries.push({
      country: 'Others',
      name: 'Others', // Add name field for consistency
      count: othersCount,
      percentage: parseFloat(((othersCount / totalCount) * 100).toFixed(1))
    });
  }

  // Add name field if missing and ensure consistency
  finalCountries = finalCountries.map(country => ({
    country: country.country || country.name || 'Unknown',
    name: country.name || country.country || 'Unknown',
    count: country.count || 0,
    percentage: country.percentage || parseFloat(((country.count / totalCount) * 100).toFixed(1))
  }));

  return finalCountries;
};

export const prepareTooltipCountryData = (countryDistribution) => {
  if (!countryDistribution || !Array.isArray(countryDistribution)) {
    return { chartData: null, countries: [], colors: [] };
  }

  const processedData = processCountryData(countryDistribution);
  
  if (!Array.isArray(processedData) || processedData.length === 0) {
    return { chartData: null, countries: [], colors: [] };
  }
  
  const colors = generateColors(processedData.length);
  
  const result = {
    chartData: {
      labels: processedData.map(item => item.name || item.country),
      datasets: [{
        data: processedData.map(item => item.count),
        backgroundColor: colors,
        borderColor: colors.map(color => color.replace('0.8', '1')),
        borderWidth: 1
      }]
    },
    countries: processedData.map((item, index) => ({
      country: item.name || item.country,
      count: item.count,
      percentage: ((item.count / countryDistribution.length) * 100).toFixed(1)
    })),
    colors: colors
  };

  return result;
};
